import React, { useCallback, useState } from 'react';
import { DataGridProProps, useGridApiRef } from '@mui/x-data-grid-pro';
import { TEntity } from '../../../../models/entity';
import {
    TreeRowsBuilderProps,
    useTreeRowsBuilder,
} from '../../../utils/treeUtils';
import {
    EditPanelDataGrid,
    EditPanelDataGridProps,
} from '../../components/EditPanelDataGrid/EditPanelDataGrid';
import { CustomGridTreeDataGroupingCell } from '../../components/TreeAdminDataGrid/TreeViewAdminDataGridMui';
import { TreeCtxMenu } from './TreeCtxMenu';

export type TreeDataGridProps<T extends TEntity> =
    EditPanelDataGridProps<T> &
    TreeRowsBuilderProps<T> & {};

export function TreeDataGrid<T extends TEntity>(
    props: TreeDataGridProps<T>
) {
    const {
        rows: initialRow,
        columns,
        propertyId,
        parentFieldID,
        apiRef: externalApiRef,
        getChildrenItems,
        ...gridProps
    } = props;

    const apiRef = useGridApiRef(externalApiRef);
    const [currentContextItem, setCurrentCtxItem] = useState<T>();
    const {
        expandedEntity,
        isGroupExpandedByDefault,
        treeRows,
        handleNodeLessCallback,
        handleExpandChildrenForItem,
        handleHideAll,
        isFetching,
        handleExpandAllNodeCallback,
        ...tree
    } = useTreeRowsBuilder<T>({
        gridId: props.gridId,
        parentFieldID: parentFieldID,
        propertyId: propertyId,
        parentPropertyId: props.parentPropertyId,
        rows: initialRow,
        defaultExpandAll: props.defaultExpandAll,
        getAllNode: props.getAllNode,
        getChildrenItems: getChildrenItems,
    } as TreeRowsBuilderProps<T>);

    const groupingColDef: DataGridProProps['groupingColDef'] = {
        ...columns[0],
        renderCell: params => (
            <CustomGridTreeDataGroupingCell
                {...params}
                filedIdName={columns[0].field}
                expandChildren={tree.expandChildren}
                hideChildren={tree.hideChildren}
                propertyId={propertyId.toString()}
                parentPropertyId={props.parentPropertyId?.toString()}
            />
        ),
    };


    const expandeLessItem = useCallback(() => {
        if (currentContextItem) handleNodeLessCallback(currentContextItem);
    }, [currentContextItem, handleNodeLessCallback]);

    const expandItem = useCallback(() => {
        if (currentContextItem) handleExpandChildrenForItem(currentContextItem);
    }, [currentContextItem, handleExpandChildrenForItem]);

    const expandAll = useCallback(() => {
        handleExpandAllNodeCallback();
    }, [handleExpandAllNodeCallback]);

    const expandeLessAll = useCallback(() => {
        handleHideAll();
    }, [handleHideAll]);

    return (
        <EditPanelDataGrid
            {...gridProps}
            apiRef={apiRef}
            enableContextMeny={true}
            getCurrentItemCtxMenu={(selected: T) => {
                if (props.getCurrentItemCtxMenu)
                    props.getCurrentItemCtxMenu(selected);
                setCurrentCtxItem(selected);
            }}
            contentContextMenu={
                <div>
                    {props.contentContextMenu}
                    <TreeCtxMenu
                        expandItem={expandItem}
                        expandAll={expandAll}
                        expandeLessItem={expandeLessItem}
                        expandeLessAll={expandeLessAll}
                    />
                </div>
            }
            loading={props.loading || isFetching}
            // getRowId={(row) => {
            //     const id = propertyId ? row[propertyId as string] : row.id;
            //     return id;
            // }}
            treeData={props.treeData === undefined ? true : props.treeData}

            isGroupExpandedByDefault={isGroupExpandedByDefault}
            columns={[...columns]}
            getTreeDataPath={tree.getTreeDataPath}
            groupingColDef={groupingColDef}
            rows={treeRows}
        />

    );

}
